import React from 'react';
import { DesktopMoreMenuProps } from './Header.types';

const DesktopMoreMenu = ({ data, isMenuShown }: DesktopMoreMenuProps) => {
  const tabValue = isMenuShown ? undefined : -1;

  return (
    <div className="tfl-header__more-menu-desktop">
      <div className="tfl-header__list1">
        <h2 className="tfl-header__more-menu-desktop-header">
          {data?.lists.list1.header}
        </h2>
        <ul className="tfl-header__list-container">
          {data?.lists.list1.links.map(
            (
              link: { url: string | undefined; text: React.ReactNode },
              i: string | number | null | undefined
            ) => (
              <li key={i} className="tfl-header__more-menu-desktop-item">
                <a
                  href={link.url}
                  tabIndex={tabValue}
                  className="tfl-header__more-menu-desktop-link"
                >
                  {link.text}
                </a>
              </li>
            )
          )}
        </ul>
      </div>
      <div className="tfl-header__list2">
        <h2 className="tfl-header__more-menu-desktop-header">
          {data?.lists.list2.header}
        </h2>
        <div className="tfl-header__list2-inner">
          <ul className="tfl-header__list-container">
            {data?.lists.list2.links.map(
              (
                link: { url: string | undefined; text: React.ReactNode },
                i: string | number | null | undefined
              ) => (
                <li key={i} className="tfl-header__more-menu-desktop-item">
                  <a
                    href={link.url}
                    tabIndex={tabValue}
                    className="tfl-header__more-menu-desktop-link"
                  >
                    {link.text}
                  </a>
                </li>
              )
            )}
          </ul>
        </div>
      </div>
      <div className="tfl-header__list3">
        <h2 className="tfl-header__more-menu-desktop-header">
          {data?.lists.list3.header}
        </h2>
        <ul className="tfl-header__list-container">
          {data?.lists.list3.links.map(
            (
              link: { url: string | undefined; text: React.ReactNode },
              i: string | number | null | undefined
            ) => (
              <li key={i} className="tfl-header__more-menu-desktop-item">
                <a
                  href={link.url}
                  tabIndex={tabValue}
                  className="tfl-header__more-menu-desktop-link"
                >
                  {link.text}
                </a>
              </li>
            )
          )}
        </ul>
      </div>
    </div>
  );
};

export default DesktopMoreMenu;
